// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"188":"ddeda7c5","764":"484e2384"}[chunkId] + ".chunk.css");